import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

import logo from '../assets/icons/logo.svg';
import { getUser, logout } from '../services/Api';

import './Header.css';

import settingsIcon from '../assets/icons/option.svg';
import supportIcon from '../assets/icons/pod.svg';
import historyIcon from '../assets/icons/svits.svg';
import mainIcon from '../assets/icons/user.svg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation(); // Получаем текущий location

  useEffect(() => {
    const checkSession = async () => {
      try {
        const userData = await getUser();
        setIsAuthenticated(!!userData); // true, если пользователь найден, иначе false
      } catch (error) {
        setIsAuthenticated(false);
        console.error('Ошибка при проверке состояния сессии:', error);
      }
    };

    checkSession();
  }, [location.pathname]); // Выполняется при каждом изменении пути

  const toggleMenu = () => {
    setIsMenuOpen(prevState => !prevState);
  };

  // Функция для закрытия меню
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navigate = useNavigate(); // Инициализация навигации

  const handleLogout = async () => {
    try {
      const response = await logout();
      if (response.success) {
        setIsAuthenticated(false);
        closeMenu(); // Закрываем меню при выходе
        navigate('/'); // Перенаправляем на главную страницу
      }
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    }
  };

  return (
    <header className="header">
      <div className="header__container">
        <div className="header__logo">
          <Link to="/">
            <img src={logo} alt="Логотип" />
          </Link>
        </div>

        {/* Добавлен класс для неавторизованных пользователей */}
        <div
          className={`header__block ${isMenuOpen ? 'active' : ''} ${!isAuthenticated ? 'header__block--unauth' : ''}`}
        >
          <nav className="header_nav">
            <ul className="nav__list">
              {isAuthenticated ? (
                <>
                  <li className="nav__item">
                    <Link to="/profile" className="nav__link" onClick={closeMenu}>
                      <img src={mainIcon} alt="Главная" className="nav-icon" />
                      Главная
                    </Link>
                  </li>
                  <li className="nav__item">
                    <Link to="/history" className="nav__link" onClick={closeMenu}>
                      <img src={historyIcon} alt="История" className="nav-icon" />
                      История профилей
                    </Link>
                  </li>
                  <li className="nav__item">
                    <Link to="/setting" className="nav__link" onClick={closeMenu}>
                      <img src={settingsIcon} alt="Настройки" className="nav-icon" />
                      Настройка
                    </Link>
                  </li>
                  <li className="nav__item">
                    <a
                      href="https://t.me/loverbotsupport" // Замените на ссылку вашего канала
                      className="nav__link"
                      target="_blank" // Открыть в новой вкладке
                      rel="noopener noreferrer" // Рекомендуется для безопасности
                      onClick={closeMenu} // Если нужно закрыть меню
                    >
                      <img src={supportIcon} alt="Telegram" className="nav-icon" />
                      Поддержка
                    </a>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav__item">
                    <ScrollLink to="about" smooth={true} duration={500} onClick={closeMenu}>
                      О нас
                    </ScrollLink>
                  </li>
                  <li className="nav__item">
                    <ScrollLink to="advantage" smooth={true} duration={500} onClick={closeMenu}>
                      Преимущества
                    </ScrollLink>
                  </li>
                  <li className="nav__item">
                    <ScrollLink to="faq" smooth={true} duration={500} onClick={closeMenu}>
                      FAQ
                    </ScrollLink>
                  </li>
                </>
              )}
            </ul>
          </nav>

          <div className="header__actions">
            {!isAuthenticated ? (
              <Link to="/login" id="login-button" className="header__button" onClick={closeMenu}>
                Войти
              </Link>
            ) : (
              <button id="logout-button" className="header__button" onClick={handleLogout}>
                Выйти
              </button>
            )}
          </div>
        </div>

        <div className="burger" onClick={toggleMenu}>
          <span className={`burger__line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`burger__line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`burger__line ${isMenuOpen ? 'active' : ''}`}></span>
        </div>
      </div>
    </header>
  );
};

export default Header;
